import img1 from "../Assets/testimonials/1st.jpg";
import img2 from "../Assets/testimonials/2nd.jpg";

export const testimonials = [
  {
    id: "olivia-lumina-review",
    heading: "⭐⭐⭐⭐⭐ Verified Review",
    description:
      '"Lumina is a polished, thoughtfully structured React portfolio template. The layout is clean, components are reusable, theming is handled with CSS variables, and animations are tastefully encapsulated. Everything feels modern and easy to extend. Routing is sensible, assets are optimized, and the building blocks (Buttons, Cards, Section headers) make customization a breeze. Overall, an excellent starting point that’s friendly for beginners and scalable for pros."',
    articleLinkText: "Trusted By Developers →",
    articleLink:
      "https://sobia.gumroad.com/l/lumina-reactjs-portfolio-template",
    name: "Olivia Wilcox",
    title: "Founder & Senior SRE",
    image: img1,
  },
  {
    id: "dimitrios-collaboration",
    heading: "🤝 Collaboration Feedback",
    description:
      "As a company founder, I look at products not only for how they look, but for the clarity of the problem they solve. It is a personal story, a credibility signal, and often the first impression before any conversation happens. Lumina feels clean, solid, and approachable, with a clear focus on helping developers launch their portfolio faster and with more confidence. I especially like the direction of making customization and deployment easier. Overall, a thoughtful starting point for developers who want a polished personal portfolio.",
    articleLinkText: "View Collaboration →",
    articleLink: "https://tools.aspectsoft.gr/lumina",
    name: "Dimitrios S. Sfyris",
    title: "Founder & Lead Developer",
    image: img2,
  },
  {
    id: "olivia-featured-article",
    heading: "📝 Featured Article",
    description:
      "Sobia approached Lumina’s design with the idea that simplicity can still feel personal. Lumina’s structure reflects that intention. Each section guides the reader naturally from who you are, what you build, and how you approach your craft. Sobia’s work on Lumina reflects her larger belief that code can be a creative medium.  When asked what she wants users to feel as they build their own Lumina sites, she said, “confidence and self-expression.”",
    articleLinkText: "Read Article →",
    articleLink:
      "https://www.linkedin.com/pulse/lighting-way-developers-inside-lumina-new-kind-portfolio-wilcox-zwige/",
    name: "Olivia Wilcox",
    title: "Founder & Senior SRE",
    image: img1,
  },
];
